import * as React from "react";
import * as ReactDOM from 'react-dom';
import * as injectTapEventPluginExport from 'react-tap-event-plugin';
import axios from 'axios';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { AppContainer } from 'react-hot-loader';

import SongVoters from './components/voters/SongVoters';
import SongCardListScrollWithData from './components/songs/hoc/SongCardListScrollWithData';
import GuitarChords from "./components/guitar/GuitarChords";
import ChordsList from "./components/common/ChordsList";
import TuningsList from "./components/guitar/TuningsList";
import InstrumentsList from "./components/guitar/InstrumentsList";

// workaround from:
// https://stackoverflow.com/questions/37918329/material-ui-dependencies-react-tap-event-plugin-has-no-exported-member-inj
const injectTapEventPlugin = (injectTapEventPluginExport as any).default;
injectTapEventPlugin();

window.app = window.app || {};

const userClickHandler = (username) => {
    window.location.href = '/user/' + username;
};

const doRenderTopVoters = async () => {

    const fallbackImg = "https://dncam6j1wwh88.cloudfront.net/user.png";

    const res = await axios({
        method: 'GET',
        url: `/api/v1/songs/${(window as any).songId}/voters`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
    });

    ReactDOM.render(
        <AppContainer>
            <SongVoters
            userClickHandler={userClickHandler}
            voters={(res as any).data}
            fallbackImage={fallbackImg}/>
        </AppContainer>
            ,
        document.getElementById('react_voters_list'));

};

if (document.getElementById('react_voters_list')) {
    //noinspection JSIgnoredPromiseFromCall
    doRenderTopVoters();
}

const doNotRender = ['follows', 'followed'];

if (document.getElementById('row_results') && doNotRender.indexOf((window as any).subtype) < 0) {
    ReactDOM.render(
        <MuiThemeProvider>
            <SongCardListScrollWithData apiUrl={(window as any).apiUrl} type={(window as any).type}/>
        </MuiThemeProvider>,
        document.getElementById('row_results'));
}

window.app["doRenderChords"] = () => {
    var guitarChords = document.getElementById('guitar-chords-container');
    if (guitarChords) {
        ReactDOM.render(
            <GuitarChords/>,
            guitarChords
        );
    }

    ReactDOM.render(
        <ChordsList />,
        document.getElementById('chords-list-container')
    );
};

window.app["doRenderTuningsList"] = () => {
    ReactDOM.render(
        <TuningsList />,
        document.getElementById('tunings')
    );
};

window.app["doRenderInstrumentsList"] = () => {
    ReactDOM.render(
        <InstrumentsList />,
        document.getElementById('instruments')
    );
};




// WEBPACK FOOTER //
// ./ReactMain.tsx